import Slider from 'react-slick';
import { Image } from 'react-datocms';
import { twMerge } from 'tailwind-merge';
import { NextArrow, PrevArrow } from './SliderArrows';
import { StripFragment } from '@/utils/dato/generated';
import { useBreakpointValue } from '@/utils/hooks/useBreakpointValue';

const SLIDES_TO_SHOW_BREAKPOINTS = [{ maxWidth: 768, value: 2 }];

type LogoPanelProps = {
  elements: NonNullable<StripFragment['elements']>;
};

export const LogoPanel = ({ elements }: LogoPanelProps) => {
  const slidesToShow = useBreakpointValue(SLIDES_TO_SHOW_BREAKPOINTS, 5);

  if (slidesToShow === undefined) {
    return null;
  }

  return (
    <div
      className={twMerge('strip-items relative [&_.slick-track]:mx-auto', 'strip--logo-panel')}
      aria-label="Partner logos"
      role="region"
    >
      <Slider
        slidesToShow={slidesToShow}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        slidesToScroll={1}
        infinite={false}
        dots={false}
        arrows
      >
        {elements.map(({ image, id }) => {
          const responsiveImage = image?.responsiveImage;

          return (
            <div className="md:px-4 md:w-auto lg:flex-1" key={id}>
              {responsiveImage ? (
                <div className="w-full mb-6">
                  <Image style={{ margin: '0 auto' }} objectPosition="50% 50%" data={responsiveImage} />
                </div>
              ) : null}
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
